<template>
  <div class="page-navbar">
    <c-nav-menu
      class="navbar"
      :menu="menu"
      :routes="routes"
      :default-active="$route.name"
      :replace-router="replaceRouter"
    />
    <router-view class="router-view" :key="$route.fullPath" />
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class NavbarLayout extends Vue {
  @Prop(Array) routes;
  @Prop({ type: Boolean, default: true }) replaceRouter;

  menu = {
    mode: 'horizontal'
  }
}
</script>

<style lang="scss" scoped>
  .page-navbar {
    height: 100%;
    display: flex;
    flex-direction: column;

    .navbar {
      flex-shrink: 0;
      padding: 0 30px;
    }

    .router-view {
      flex: 1;
      overflow: scroll;
    }
  }
</style>
